import { Component, OnInit, Input, ChangeDetectionStrategy, ContentChild, TemplateRef } from '@angular/core';
import { RequestRoot } from 'types';
import { AppContext } from '../control/context';

@Component({
  selector: 'i-field-a',
  templateUrl: './fieldA.component.html',
  styleUrls: ['./fieldA.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class FieldAComponent implements OnInit {
  @Input() model: RequestRoot;
  @Input() path: string;
  @Input() i18n_name: string;
  @Input() hint: boolean;

  @ContentChild(TemplateRef, { static: false }) hintContent: TemplateRef<any>;

  _i18n_name: string;

  private pathSteps: string[];

  constructor(private appContext: AppContext) {}

  visible(): boolean {
    return undefined !== this.pathSteps.reduce((pv, cv) => (pv === undefined ? undefined : pv[cv]), this.model.features);
  }

  set intModel(val) {
    const it = this.pathSteps.slice(0, -1).reduce((pv, cv) => pv[cv], this.model.features);
    it[this.pathSteps.slice(-1)[0]] = val;
    this.appContext.storeDraft(this.model);
  }

  get intModel() {
    const val = this.pathSteps.reduce((pv, cv) => pv[cv], this.model.features);
    return val;
  }

  ngOnInit() {
    this.pathSteps = this.path.split('.');
    if (this.i18n_name) {
      this._i18n_name = this.appContext.getI18NString(this.i18n_name);
    }
  }

  get suggestionTitle() {
    return this.appContext.getI18NString('suggestion');
  }
}
